import {BILLING_PRICE as DEFAULT_PRICE} from '../../../fixtures';

export default ({
  keys,
  server,
  activePrice,
  formattedActivePriceAmount,
}) => `<!DOCTYPE html>
<html>
  <head>
    <title>Subscribe to a cool new product</title>
    <link rel="stylesheet" href="${
      server === 'php' ? 'public/style.css' : 'style.css'
    }">
    <script src="https://polyfill.io/v3/polyfill.min.js?version=3.52.1&features=fetch"></script>
    {+load-stripe}
    <script src="https://js.stripe.com/v3/"></script>
    {/load-stripe}
  </head>
  <body>
    <section>
      {+preview-page}
      <div class="product">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14px" height="16px" viewBox="0 0 14 16" version="1.1">
            <defs/>
            <g id="Flow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="0-Default" transform="translate(-121.000000, -40.000000)" fill="#E184DF">
                    <path d="M127,50 L126,50 C123.238576,50 121,47.7614237 121,45 C121,42.2385763 123.238576,40 126,40 L135,40 L135,56 L133,56 L133,42 L129,42 L129,56 L127,56 L127,50 Z M127,48 L127,42 L126,42 C124.343146,42 123,43.3431458 123,45 C123,46.6568542 124.343146,48 126,48 L127,48 Z" id="Pilcrow"/>
                </g>
            </g>
        </svg>
        {+pricing-model}
        <div class="description">
          <h3>${(activePrice || DEFAULT_PRICE)?.product.name}</h3>
          <h5>${formattedActivePriceAmount ||
            DEFAULT_PRICE.formattedActivePriceAmount}</h5>
        </div>
        {/preview-page}
      </div>
      {+add-checkout-button}
      <form action="/create-checkout-session${
        server === 'php' ? '.php' : ''
      }" method="POST">
        <input type="hidden" name="lookup_key" value="${
          activePrice
            ? `${activePrice.lookup_key}`
            : `// TODO: {{PRICE_LOOKUP_KEY}} replace with \`price.lookup_key\``
        }" />
        {/pricing-model}
        <button id="checkout-and-portal-button" type="submit">Checkout</button>
      </form>
      {/add-checkout-button}
    </section>
  </body>
</html>`;
